import { Link } from "react-router-dom";
import styles from "../styles/Site.module.css";
import { Note, ResearchItem, Review, LinkItem } from "../content/writing";

const Links = ({ links }: { links: LinkItem[] }) => {
    return (
        <p className={styles.entryLinks}>
            {links.map((link, index) => {
                const inner = link.href.startsWith("/") ? (
                    <Link to={link.href}>{link.label}</Link>
                ) : (
                    <a href={link.href}>{link.label}</a>
                );
                return (
                    <span key={link.href}>
                        {index > 0 && <span className={styles.sep}> · </span>}
                        {inner}
                    </span>
                );
            })}
        </p>
    );
};

export const ResearchList = ({ items }: { items: ResearchItem[] }) => {
    return (
        <div>
            {items.map((item) => (
                <article key={item.title} className={styles.entry}>
                    <h3 className={styles.entryTitle}>{item.title}</h3>
                    <p className={styles.entryMeta}>
                        {item.authors}. {item.venue}, {item.year}.
                    </p>
                    <Links links={item.links} />
                </article>
            ))}
        </div>
    );
};

export const NoteList = ({ items }: { items: Note[] }) => {
    return (
        <div>
            {items.map((note) => (
                <article key={note.title} className={styles.entry}>
                    <h3 className={styles.entryTitle}>{note.title}</h3>
                    <p className={styles.entryMeta}>
                        {note.date}. {note.description}
                    </p>
                    <Links links={note.links} />
                </article>
            ))}
        </div>
    );
};

export const ReviewList = ({ items }: { items: Review[] }) => {
    return (
        <div>
            {items.map((review) => (
                <article key={review.href} className={styles.entry}>
                    <h3 className={styles.entryTitle}>
                        <Link to={review.href}>{review.title}</Link>
                    </h3>
                    <p className={styles.entryMeta}>
                        {review.author}, {review.date}
                    </p>
                </article>
            ))}
        </div>
    );
};
